import axios from "axios";

export const get_premium_history = () => dispatch => {
    axios
        .get(
            "/api/user/premium",
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        )
        .then(res => {
            dispatch({
                type: "SET_PREMIUM_HISTORY",
                history: res.data.history,
                current: res.data.current
            });
        })
        .catch(err => {
            // toto sa nemoze stat
        });
};
export const purchase_premium = (street, city, postal_code, country_code, phone_number, days, tier, coupon) => dispatch => {
    return axios
        .post(
            "/api/user/premium",
            JSON.stringify({street, city, postal_code, country_code, phone_number, days, tier, coupon}),
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        );
};

export const new_payment = (premium_id) => dispatch => {
    return axios
        .post(
            "/api/user/premium/" + premium_id + "/new-payment",
            "",
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        );
};
export const cancel_premium_order = (premium_id) => dispatch => {
    return axios
        .delete(
            "/api/user/premium/" + premium_id,
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        );
};
export const checkCouponCode = (code, subscription) => dispatch => {
    return axios
        .post(
            "/api/check-coupon",
            JSON.stringify({code, subscription}),
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        );
};

